"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ServiceItemAttributeList;
var _react = _interopRequireDefault(require("react"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _components = require("@bluefin/components");
/* eslint-disable react/prop-types */

function ServiceItemAttributeList(_ref) {
  var _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? [] : _ref$attributes,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? ':' : _ref$separator;
  if ((0, _isEmpty2["default"])(attributes)) {
    return null;
  }
  var finalClassname = "extra-attributes ".concat(className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: finalClassname
  }, attributes.map(function (_ref2) {
    var label = _ref2.label,
      description = _ref2.description,
      icon = _ref2.icon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: label
    }, /*#__PURE__*/_react["default"].createElement(_components.FishermanIcon, {
      iconName: icon
    }), /*#__PURE__*/_react["default"].createElement("strong", null, label, separator, ' '), /*#__PURE__*/_react["default"].createElement(_components.MarkdownContent, {
      content: description
    }));
  }));
}